module.exports = __webpack_public_path__ + "static/img/bg-03.cde7cad.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/form/design/assets/bg-03.png
// module id = +zOI
// module chunks = 64